<template>
    <div class="row">
        <div class="col">
            <v-breadcrumbs :items="items">
                <template v-slot:item="{ item }">
                    <v-breadcrumbs-item
                        :href="item.href"
                        @click.prevent="$inertia.get(item.href)"
                        :disabled="item.disabled"
                    >
                        {{ item.text }}
                    </v-breadcrumbs-item>
                </template>
            </v-breadcrumbs>
        </div>
    </div>
</template>

<script>
export default {
    name: "Breadcrumbs",

    props: {
        items: {
            type: Array,
            required: true,
        },
    },

    methods: {
        urlMaker(path) {
            return location.origin + path;
        },
    },

    computed: {
        breadceumbsForJsonLD() {
            let position = 1;

            return this.items.reduce((carry, item) => {
                if (item.href) {
                    carry.push({
                        "@type": "ListItem",
                        position: position,
                        name: item.text,
                        item: this.urlMaker(item.href),
                    });

                    position++;

                    return carry;
                }
            }, []);
        },
    },

    jsonld() {
        return {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: this.breadceumbsForJsonLD,
        };
    },
};
</script>

<style scoped></style>
